import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import CookieConsent from "./components/CookieConsent";
import Index from "./pages/Index";
import AboutPage from "./pages/AboutPage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import ServicesPage from "./pages/ServicesPage";
// import ClientsPage from "./pages/ClientsPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import ContactPage from "./pages/ContactPage";
import NotFound from "./pages/NotFound";
import { ScrollToTop } from "./components/utils/ScrollToTop";
import VacanciesPage from "./pages/VacanciesPage";
import VacancyDetailPage from "./pages/VacancyDetailPage";

// Admin Pages
import AdminLayout from "./components/layout/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ProductsAdmin from "./pages/admin/ProductsAdmin";
import ServicesAdmin from "./pages/admin/ServicesAdmin";
// import ClientsAdmin from "./pages/admin/ClientsAdmin";
import NewsAdmin from "./pages/admin/NewsAdmin";
import SettingsAdmin from "./pages/admin/SettingsAdmin";
import MessagesAdmin from "./pages/admin/MessagesAdmin";
import LoginPage from "./pages/admin/LoginPage";
import AdminRoute from "./components/utils/AdminRoute";
import DictionariesAdmin from "./pages/admin/DictionariesAdmin";
import VacanciesAdmin from "./pages/admin/VacanciesAdmin";
import VacanciesFeedbackAdmin from "./pages/admin/VacanciesFeedbackAdmin";
import SubscribersAdmin from "./pages/admin/SubscribersAdmin";


const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollToTop />
          <CookieConsent />
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/:productId" element={<ProductDetailPage />} />
            <Route path="/services" element={<ServicesPage />} />
            {/* <Route path="/clients" element={<ClientsPage />} /> */}
            <Route path="/news" element={<NewsPage />} />
            <Route path="/news/:newsId" element={<NewsDetailPage />} />
            <Route path="/vacancies" element={<VacanciesPage />} />
            <Route path="/vacancies/:vacancyId" element={<VacancyDetailPage />} />
            <Route path="/contact" element={<ContactPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<LoginPage />} />
            <Route element={<AdminRoute />}>
              <Route element={<AdminLayout />}>
                <Route path="/admin" element={<Dashboard />} />
                <Route path="/admin/products" element={<ProductsAdmin />} />
                <Route path="/admin/services" element={<ServicesAdmin />} />
                {/* <Route path="/admin/clients" element={<ClientsAdmin />} /> */}
                <Route path="/admin/news" element={<NewsAdmin />} />
                <Route path="/admin/vacancies" element={<VacanciesAdmin />} />
                <Route path="/admin/vacancies-feedback" element={<VacanciesFeedbackAdmin />} />
                <Route path="/admin/settings" element={<SettingsAdmin />} />
                <Route path="/admin/messages" element={<MessagesAdmin />} />
                <Route path="/admin/dictionaries" element={<DictionariesAdmin />} />
                <Route path="/admin/subscribers" element={<SubscribersAdmin />} />
              </Route>
            </Route>
            
            {/* Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
